import BrButton from '@govbr/react-components/lib/BrButton';
import { useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import avisoIndicativoNascimento from '../../../assets/img/aviso-indicativo-nascimento.svg';
import { AcaoIndicativoNascimento } from '../../../api/indicativoNascimentoAPI';
import {
  registrarAcaoIndicativoNascimento,
  selectFamiliaIndicativoNascimento,
  selectIntegranteIndicativoNascimento,
  setEtapaIndicativo,
} from '../indicativoNascimentoSlice';
import ModalNaoIncluir from '../ModalNaoIncluir/ModalNaoIncluir';
import styles from './IndicativoNascimentoConfirmacao.module.css';

const IndicativoNascimentoConfirmacao: React.FC = () => {
  const dispatch = useAppDispatch();
  const [modalAberto, setModalAberto] = useState(false);
  const [loadingNaoIncluir, setLoadingNaoIncluir] = useState(false);
  const integrante = useAppSelector(selectIntegranteIndicativoNascimento);
  const familia = useAppSelector(selectFamiliaIndicativoNascimento);
  const primeiroNome = integrante?.nome?.split(' ')?.[0] ?? '';

  const handleNaoIncluir = async () => {
    if (familia?.nuFamiliar && integrante?.cpf) {
      setLoadingNaoIncluir(true);
      await dispatch(registrarAcaoIndicativoNascimento({
        numeroFamiliar: familia.nuFamiliar,
        cpfIntegrante: integrante.cpf,
        codigoAcao: AcaoIndicativoNascimento.NAO_DESEJA_INCLUIR,
      }));
      setLoadingNaoIncluir(false);
    }
    setModalAberto(false);
    dispatch(setEtapaIndicativo('compareca-ao-cras'));
  };

  return (
    <div className={styles.container}>
      <div className={styles.imagemWrapper}>
        <img
          className={styles.imagem}
          src={avisoIndicativoNascimento}
          alt="Indicativo de nascimento"
        />
      </div>
      <div className={styles.conteudo}>
        <p className={styles.textoPrincipal}>
          Ótimo.<br />
          Precisamos que você responda algumas perguntas sobre <strong>{primeiroNome}</strong> para confirmar a inclusão.
        </p>
        <BrButton className={styles.botaoResponder} onClick={() => dispatch(setEtapaIndicativo('perguntas'))}>
          Responder
        </BrButton>
        <BrButton className={styles.botaoNao} onClick={() => setModalAberto(true)}>
          Não quero responder
        </BrButton>
        <p className={styles.aviso}>
          Se você não responder, a inclusão não será confirmada e o Responsável Familiar (RF) deverá comparecer ao CRAS para atualização cadastral.
        </p>
      </div>
      <ModalNaoIncluir
        open={modalAberto}
        onContinuar={() => { setModalAberto(false); dispatch(setEtapaIndicativo('perguntas')); }}
        onNaoIncluir={handleNaoIncluir}
        loadingNaoIncluir={loadingNaoIncluir}
      />
    </div>
  );
};

export default IndicativoNascimentoConfirmacao;
